// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"ff13328b","101":"06eb9994","249":"74fc8258","254":"63740a37","496":"8bbd7491","551":"a568847f"}[chunkId] + ".chunk.css";
};